import { render } from "./StorySelectionModal.vue?vue&type=template&id=45ccd636&lang=html"
import script from "./StorySelectionModal.vue?vue&type=script&lang=js"
export * from "./StorySelectionModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__